'use strict';

var implementation$1 = require('./implementation.js');

var implementation = implementation$1;

var polyfill = function getPolyfill() {
	return typeof Object.entries === 'function' ? Object.entries : implementation;
};

module.exports = polyfill;
